<template>
  <iframe class="iframe" src="https://spectral.energy/" />
</template>

<script>
export default {
  name: 'SpectralSite',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe {
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  border: 0;
  box-shadow: 0 0 10px 1px rgba(38, 38, 38, 0.3);
  background-color: #fff;
}
</style>
